import React from 'react';

const Footer = (props) => (
  <footer className="border-top footer text-muted" data-testid="footer" id="footer">
    <div className="container">
      <div className="row">
        <div className="col">{props.copy}</div>
        <div className="col text-right">{props.stage}</div>
      </div>
    </div>
  </footer>
);

export default Footer